import React from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

// One-click colour presets for the spin wheel (rim, segments, pointer + game buttons).
export const WHEEL_THEMES = [
  { id: "fastfood", rim: "#264F36", win: ["#DA291C", "#FFC72C"], lose: "#FFFFFF", button: "#DA291C", text: "#FFFFFF" },
  { id: "noel", rim: "#14532D", win: ["#C8102E", "#D4AF37"], lose: "#FFFFFF", button: "#C8102E", text: "#FFFFFF" },
  { id: "valentin", rim: "#9D174D", win: ["#E11D48", "#F472B6"], lose: "#FFF1F2", button: "#E11D48", text: "#FFFFFF" },
  { id: "halloween", rim: "#1C1917", win: ["#F97316", "#7C3AED"], lose: "#FFF7ED", button: "#F97316", text: "#FFFFFF" },
  { id: "luxe", rim: "#0A0A0A", win: ["#D4AF37", "#A67C00"], lose: "#FAF7F0", button: "#D4AF37", text: "#0A0A0A" },
];

export function themePatch(theme, segments) {
  let w = 0;
  return {
    wheel_rim_color: theme.rim,
    button_bg_color: theme.button,
    button_bg_color_2: null,
    button_text_color: theme.text,
    segments: (segments || []).map((s) =>
      ({ ...s, color: s.is_winning ? theme.win[w++ % theme.win.length] : theme.lose })
    ),
  };
}

export function WheelThemePresets({ game, patch }) {
  const { t } = useTranslation();
  const apply = (theme) => {
    patch(themePatch(theme, game.segments));
    toast.success(t("game_editor.wheel_theme_applied", { name: t(`game_editor.wheel_theme_${theme.id}`) }));
  };
  return (
    <div className="mb-3" data-testid="wheel-themes">
      <label className="text-[11px] text-muted-foreground block mb-1.5">{t("game_editor.wheel_themes")}</label>
      <div className="flex flex-wrap gap-1.5">
        {WHEEL_THEMES.map((th) => {
          const active = game.wheel_rim_color === th.rim && game.button_bg_color === th.button;
          return (
            <button
              key={th.id}
              type="button"
              onClick={() => apply(th)}
              aria-pressed={active}
              data-testid={`wheel-theme-${th.id}`}
              className={`flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-medium transition-colors ${
                active ? "border-violet-500 bg-violet-500/10" : "border-border hover:border-violet-300"
              }`}
            >
              <span className="flex -space-x-1">
                {[th.rim, ...th.win, th.lose].map((c, i) => (
                  <span key={i} className="h-3 w-3 rounded-full ring-1 ring-black/10" style={{ background: c }} />
                ))}
              </span>
              {t(`game_editor.wheel_theme_${th.id}`)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
